import React, { useState } from 'react';
import { ClientsTable } from '../components/clients/ClientsTable';
import { CreateClientModal } from '../components/clients/CreateClientModal';
import { ClientCreate } from '../api/models/ClientCreate';
import { clientService } from '../services/clientService';

export const ClientsPage: React.FC = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshClients, setRefreshClients] = useState(0);

  const handleClientCreated = (_client: ClientCreate) => {
    // Clear client cache so new client appears in all dropdowns
    clientService.clearCache();
    // Trigger refresh of clients table
    setRefreshClients(prev => prev + 1);
  };

  return (
    <div className="page">
      <div className="page-content">
        <div className="page-header">
          <div className="page-title">
            <h1>👥 Client Management</h1>
            <p>Client Organization Overview</p>
          </div>
          <div className="page-actions">
            <button
              className="create-client-btn"
              data-testid="btn-add-client"
              onClick={() => setShowCreateModal(true)}
            >
              <span className="add-type-icon" aria-hidden="true">+</span>
              Add Client
            </button>
          </div>
        </div>

        <ClientsTable
          onClientSelect={() => {}}
          refreshTrigger={refreshClients}
        />

        <CreateClientModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onClientCreated={handleClientCreated}
        />
      </div>
    </div>
  );
};